var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "27px",
    viewBox: "0 0 32 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0CA55C02-E46B-46EF-BEF4-8906BE64E2DA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Milestone-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "13.0_My-Library_03",
    transform: "translate(-570.000000, -430.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy-4",
    transform: "translate(550.000000, 389.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7321195,41.4653465 L22.267679,41.4653465 C21.0176989,41.4653465 20,42.6175465 20,44.0329718 L20,59.289167 C20,60.7045163 21.0176989,61.8567923 22.267679,61.8567923 L34.1416166,61.8567923 L34.1416166,64.1577708 L29.1944112,64.1577708 C28.8219153,64.1577708 28.520064,64.4996139 28.520064,64.9211394 L28.520064,66.7018259 C28.520064,67.1235794 28.8219153,67.4653465 29.1944112,67.4653465 L42.8056559,67.4653465 C43.1781519,67.4653465 43.4800703,67.1235794 43.4800703,66.7018259 L43.4800703,64.9211394 C43.4800703,64.4996139 43.1781519,64.1577708 42.8056559,64.1577708 L37.8595921,64.1577708 L37.8595921,61.8567923 L49.7322539,61.8567923 C50.9823011,61.8567923 52,60.7045923 52,59.289167 L52,44.0329718 C52,42.6175465 50.9822339,41.4653465 49.7321195,41.4653465 Z M48.8131351,58.2485831 L23.1868649,58.2485831 L23.1868649,45.0736318 L48.8131351,45.0736318 L48.8131351,58.2485831 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenIcon);
export default __webpack_public_path__ + "static/media/ScreenIcon.01d6823814c439d53b4b0f39c8e5e160.svg";
export { ForwardRef as ReactComponent };